import { HStack, Select, Button } from "@chakra-ui/react";

const PaginationControls = ({ page, totalPages, onPageChange, pageSize, setPageSize }) => (
  <HStack mt={4} justify="space-between">
    <HStack>
      <Button onClick={() => onPageChange(page - 1)} isDisabled={page <= 1}>Prev</Button>
      <Button onClick={() => onPageChange(page + 1)} isDisabled={page >= totalPages}>Next</Button>
    </HStack>
    <Select
      size="sm"
      value={pageSize}
      onChange={(e) => setPageSize(Number(e.target.value))}
      w="100px"
    >
      {[10, 20, 50,100,10000].map((n) => <option key={n} value={n}>{n === 10000 ? "All" : `${n}/page`}</option>)}
      
    </Select>
  </HStack>
);

export default PaginationControls;
